export default __webpack_public_path__ + "static/media/AG6.99ab8ac6.jpg";